(() => {
  if (window.atelierCarouselRefinementLoaded) return;
  window.atelierCarouselRefinementLoaded = true;
  const controllers = new WeakMap();
  const carouselsWithin = (root) => [
    ...(root.matches?.('[data-atelier-carousel]') ? [root] : []),
    ...root.querySelectorAll('[data-atelier-carousel]')
  ];
  function initialize(root) {
    if (controllers.has(root)) return;
    const slides = [...root.querySelectorAll('[data-carousel-slide]')];
    if (!slides.length) return;
    root.dataset.atelierReady = 'true';
    const dots = [...root.querySelectorAll('[data-carousel-dot]')];
    const pauseButton = root.querySelector('[data-carousel-pause]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const cleanup = [];
    const listen = (target, name, handler, options) => {
      target.addEventListener(name, handler, options);
      cleanup.push(() => target.removeEventListener(name, handler, options));
    };
    let index = 0, timer, paused = reduced.matches;
    let hovering = false, focused = false, touching = false;
    const interval = Math.max(4000, Number(root.dataset.interval) || 4000);
    const clear = () => { if (timer) window.clearInterval(timer); timer = null; };
    const schedule = () => {
      clear();
      if (!paused && !hovering && !focused && !touching && !document.hidden && slides.length > 1) timer = window.setInterval(() => show(index + 1), interval);
    };
    function show(next, announce = false) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      const counter = root.querySelector('[data-carousel-current]');
      if (counter) counter.textContent = String(index + 1).padStart(2, '0');
      const status = root.querySelector('[data-carousel-status]');
      if (announce && status) status.textContent = slides[index].querySelector('h1,h2')?.textContent || '';
    }
    function pauseState() {
      if (!pauseButton) return;
      pauseButton.setAttribute('aria-pressed', String(paused));
      const ar = document.documentElement.lang === 'ar';
      pauseButton.setAttribute('aria-label', paused ? (ar ? 'تشغيل الحركة' : 'Play carousel') : (ar ? 'إيقاف الحركة' : 'Pause carousel'));
      const icon = pauseButton.querySelector('[data-pause-icon]');
      if (icon) icon.textContent = paused ? '▷' : 'Ⅱ';
    }
    dots.forEach((dot, i) => listen(dot, 'click', () => { show(i, true); schedule(); }));
    const previous = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (previous) listen(previous, 'click', () => { show(index - 1, true); schedule(); });
    if (next) listen(next, 'click', () => { show(index + 1, true); schedule(); });
    if (pauseButton) listen(pauseButton, 'click', () => { paused = !paused; pauseState(); schedule(); });
    listen(root, 'pointerenter', event => { if (event.pointerType !== 'touch') { hovering = true; clear(); } });
    listen(root, 'pointerleave', event => { if (event.pointerType !== 'touch') { hovering = false; schedule(); } });
    listen(root, 'focusin', () => { focused = true; clear(); });
    listen(root, 'focusout', event => { if (!root.contains(event.relatedTarget)) { focused = false; schedule(); } });
    listen(document, 'visibilitychange', schedule);
    listen(reduced, 'change', event => { if (event.matches) { paused = true; pauseState(); schedule(); } });
    let start;
    listen(root, 'touchstart', event => { start = event.touches[0].clientX; touching = true; clear(); }, { passive: true });
    listen(root, 'touchend', event => {
      if (start !== undefined) {
        const delta = event.changedTouches[0].clientX - start;
        if (Math.abs(delta) > 60) {
          const direction = document.documentElement.dir === 'rtl' ? -1 : 1;
          show(index + (delta < 0 ? direction : -direction), true);
        }
      }
      start = undefined; touching = false; schedule();
    }, { passive: true });
    listen(root, 'touchcancel', () => { start = undefined; touching = false; schedule(); }, { passive: true });
    controllers.set(root, () => {
      clear();
      cleanup.forEach(remove => remove());
      delete root.dataset.atelierReady;
      controllers.delete(root);
    });
    show(0); pauseState(); schedule();
  }
  carouselsWithin(document).forEach(initialize);
  document.addEventListener('shopify:section:load', event => carouselsWithin(event.target).forEach(initialize));
  document.addEventListener('shopify:section:unload', event => carouselsWithin(event.target).forEach(root => controllers.get(root)?.()));
})();
